import { render, staticRenderFns } from "./AK2Icon.vue?vue&type=template&id=24807776&scoped=true&"
import script from "./AK2Icon.vue?vue&type=script&lang=js&"
export * from "./AK2Icon.vue?vue&type=script&lang=js&"
import style0 from "./AK2Icon.vue?vue&type=style&index=0&id=24807776&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24807776",
  null
  
)

export default component.exports